<div class="tap-top"(click)="tapToTop()" [ngStyle]="{ 'display': show ? 'block' : 'none' }">
    <app-feather-icons [icon]="'chevrons-up'"></app-feather-icons>
</div>
